import React, { Component } from 'react';

import SidebarComponent from '../components/SidebarComponent';
import NavbarComponent from '../components/NavbarComponent';
import HeaderComponent from '../components/HeaderComponent';
import { validateSession } from '../utils/functions';
import { creditReasonLabel } from '../utils/usedGame';

var config = process.env;

function money(value) {
    const n = Number(value || 0);
    return `$ ${n.toLocaleString('es-UY')}`;
}

// De dónde salió la compra, en palabras del mostrador. El canal manda; para el retail, que no
// distingue, lo dice el originador (mostrador / web / Mercado Libre).
const CHANNEL_LABELS = { cafeteria: 'Cafetería', mesas: 'Mesas', eventos: 'Eventos' };
export function purchaseOrigin(purchase) {
    if (CHANNEL_LABELS[purchase.channel]) return CHANNEL_LABELS[purchase.channel];
    if (purchase.originator === 'Local') return 'Mostrador';
    if (purchase.originator === 'Página') return 'Web';
    return purchase.originator || 'Venta';
}

// Qué se compró, corto: la gracia es reconocer la compra de un vistazo, no listar el ticket.
export function purchaseItems(items) {
    const lines = (items || []).map((i) => `${i.quantity} × ${i.name}`);
    if (lines.length === 0) return null;
    if (lines.length <= 2) return lines.join(' · ');
    return `${lines.slice(0, 2).join(' · ')} +${lines.length - 2} más`;
}

class UserCreditPage extends Component {
    constructor() {
        super();
        this.state = {
            checked: false, role: 0, cedula: null,
            balance: 0, movements: [], loading: true,
            adjAmount: '', adjNotes: '', saving: false,
        };
    }

    async componentDidMount() {
        const role = await validateSession();
        const params = new URLSearchParams(this.props.location.search);
        const cedula = params.get('cedula');
        this.setState({ checked: true, role, cedula });
        this.fetchCredit(cedula);
    }

    fetchCredit = (cedula) => {
        this.setState({ loading: true });
        const request = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'access-token': localStorage.getItem('token') },
        };
        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + `store-credit/${cedula}`, request)
            .then((r) => r.json())
            .then((data) => {
                if (data.error > 0) {
                    alert(data.message);
                    if (data.error === 1002) window.location.href = localStorage.getItem('homePageURL');
                    this.setState({ loading: false });
                } else {
                    this.setState({ balance: data.data.balance, movements: data.data.movements || [], loading: false });
                }
            });
    }

    saveAdjustment = () => {
        const amount = Number(this.state.adjAmount);
        if (!amount || amount === 0) {
            alert('Ingresá un monto distinto de 0 (negativo para descontar).');
            return;
        }
        this.setState({ saving: true });
        const request = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'access-token': localStorage.getItem('token') },
            body: JSON.stringify({ amount, notes: this.state.adjNotes }),
        };
        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + `store-credit/${this.state.cedula}/adjustment`, request)
            .then((r) => r.json())
            .then((data) => {
                this.setState({ saving: false });
                if (data.error > 0) {
                    alert(data.message);
                } else {
                    this.setState({ adjAmount: '', adjNotes: '' });
                    this.fetchCredit(this.state.cedula);
                }
            });
    }

    render() {
        if (!this.state.checked) {
            return (<div></div>);
        }
        return (
            <div className="container-fluid">
                <div className="row">
                    <SidebarComponent itemSelected={3} role={this.state.role} />
                    <main className="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3">
                        <NavbarComponent role={this.state.role} />
                        <div className="main-content-container container-fluid px-4 mb-4">
                            <HeaderComponent title="Clientes" subtitle={`Crédito en tienda — cédula ${this.state.cedula}`} />

                            <div className="card card-small mb-4">
                                <div className="card-body p-4">
                                    <h6 className="text-uppercase text-muted">Saldo disponible</h6>
                                    <h3 className="mb-0">{money(this.state.balance)}</h3>
                                </div>
                            </div>

                            <div className="card card-small mb-4">
                                <div className="card-body p-4">
                                    <h6 className="text-uppercase text-muted">Ajuste manual</h6>
                                    <div className="row align-items-end">
                                        <div className="col-md-3">
                                            <label>Monto (+ acredita / - descuenta)</label>
                                            <input type="number" className="form-control" value={this.state.adjAmount} onChange={(e) => this.setState({ adjAmount: e.target.value })} />
                                        </div>
                                        <div className="col-md-6">
                                            <label>Motivo / notas</label>
                                            <input type="text" className="form-control" value={this.state.adjNotes} onChange={(e) => this.setState({ adjNotes: e.target.value })} />
                                        </div>
                                        <div className="col-md-3">
                                            <button type="button" className="btn btn-accent" disabled={this.state.saving} onClick={this.saveAdjustment}>
                                                Registrar ajuste
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="card card-small mb-4">
                                <div className="card-body p-0">
                                    <table className="table mb-0">
                                        <thead className="bg-light">
                                            <tr>
                                                <th>Fecha</th>
                                                <th>Motivo</th>
                                                <th>Compra</th>
                                                <th>Monto</th>
                                                <th>Notas</th>
                                                <th>Registrado por</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.loading && (<tr><td colSpan="6" className="text-center">Cargando…</td></tr>)}
                                            {!this.state.loading && this.state.movements.length === 0 && (
                                                <tr><td colSpan="6" className="text-center text-muted">Sin movimientos.</td></tr>
                                            )}
                                            {this.state.movements.map((m) => (
                                                <tr key={m.id}>
                                                    <td>{m.created_at ? new Date(m.created_at).toLocaleString('es-UY') : '-'}</td>
                                                    <td>{creditReasonLabel(m.reason)}</td>
                                                    {/* Qué compra fue: sin esto, "Pago de compra − $320" no le dice
                                                        nada ni al cliente ni al mostrador. */}
                                                    <td>
                                                        {m.purchase ? (
                                                            <React.Fragment>
                                                                <div>
                                                                    <strong>#{m.purchase.id}</strong>
                                                                    <span className="text-muted"> · {purchaseOrigin(m.purchase)}</span>
                                                                    {m.purchase.cancelled && (
                                                                        <span className="badge badge-danger ml-1">Anulada</span>
                                                                    )}
                                                                </div>
                                                                {purchaseItems(m.purchase.items) && (
                                                                    <small className="text-muted d-block">{purchaseItems(m.purchase.items)}</small>
                                                                )}
                                                                <small className="text-muted d-block">Compra de {money(m.purchase.total)}</small>
                                                            </React.Fragment>
                                                        ) : (
                                                            <span className="text-muted">-</span>
                                                        )}
                                                    </td>
                                                    <td style={{ color: Number(m.amount) < 0 ? '#c4183c' : '#17c671' }}>{money(m.amount)}</td>
                                                    <td>{m.notes || '-'}</td>
                                                    <td>{m.created_by || '-'}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </main>
                </div>
            </div>
        );
    }
}

export default UserCreditPage;
